/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Provider.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Checkbox from 'DesignSystem/Checkbox/logic.js'
import MaskedInputSmallLabel from 'DesignSystem/MaskedInputSmallLabel/logic.js'
import React from 'react'
import { css } from "emotion"
Checkbox.displayName = 'CheckboxLogic'
MaskedInputSmallLabel.displayName = 'MaskedInputSmallLabelLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginLeft: 8,
marginBottom: 8,
alignItems: "center"})

export default function Provider({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isSelected,
isInvalid,
onChange,
onSubmit,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/Provider"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'company.national_provider_id', 
context: 'company',
validate: 'npi',
})
    

  return (<React.Fragment
>
<div
 data-testid="Provider.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/Provider"
 className={`views-block ${styles.Horizontal}`}
>
<Checkbox
 data-testid="Provider.Checkbox"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/Provider"
viewPath={`${viewPath}/Checkbox`}
 isSelected={isSelected}
 isDisabled={true}
 marginTop={16}
 text="I'm a provider of dental services"
/>
{
isSelected ? 
<MaskedInputSmallLabel
 data-testid="Provider.MaskedInputSmallLabel"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/Provider"
viewPath={`${viewPath}/MaskedInputSmallLabel`}
 isInvalid={data.isInvalid}
 label="Company NPI (Optional)"
 mask="tenDigits"
 onChange={data.onChange}
 onSubmit={data.onSubmit}
 placeholder="0000000000&#8291;"
 type="text"
 value={data.value}
 width={200}
 marginLeft={40}
 marginTop={8}
/>
 : null
}
</div>
{children}
</React.Fragment>)
}